import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import RadioGroup from '../../../../../reusable/Form/RadioGroup.jsx';

class PeriodFilter extends React.PureComponent {

    static propTypes = {
        days: PropTypes.number
    }

    static defaultProps = {
        days: 30
    }

    constructor(props) {
        super(props);

        this.filterByPeriod = this.filterByPeriod.bind(this);
    }

    filterByPeriod(event) {
        let selectedPeriod = parseInt(event.target.value, 10);

        this.props.switchDays(selectedPeriod);
    };

    render() {
        const options = [
            { value: 1, label: this.props.intl.formatMessage({id: 'Dashboard_Charts_UIText_dashboard.ShowDataFor.lastDay'})},
            { value: 7, label: this.props.intl.formatMessage({id: 'Dashboard_Charts_UIText_dashboard.ShowDataFor.lastWeek'})},
            { value: 30, label: this.props.intl.formatMessage({id: 'Dashboard_Charts_UIText_dashboard.ShowDataFor.lastMonth'})}
        ]
        return <RadioGroup value={this.props.days} fieldId={"days-filter"}  onChange={this.filterByPeriod} options={options} classNames="notranslate"/>
    }

}

export default injectIntl(PeriodFilter);


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/FilterPod/Period.filters.jsx